module.exports = __webpack_public_path__ + "static/Basil-&-Feta-Semi-Dried-Tomato-307e555ebec926912e7a8d0a9d62cbc9.png";